import React from 'react';
import { abbreviateNum } from 'lib/helpers';
import { OverallStats, UserSnapshot } from 'lib/types/replay';

export interface Slide5Props {
  yearStart?: UserSnapshot;
  yearEnd: OverallStats;
}

/** Slide 5 - Milestones */
export const Slide05 = ({
  yearStart,
  yearEnd,
}: Slide5Props) => {
  if (!yearStart) {
    return null;
  }

  const likesFormatted = {
    start: abbreviateNum(yearStart.likes || 0, 0),
    end: abbreviateNum(yearEnd.likes, 0),
  };

  const viewsFormatted = {
    start: abbreviateNum(yearStart.combinedViews || 0, 0),
    end: abbreviateNum(yearEnd.combinedViews, 0),
  };

  const postsFormatted = {
    start: abbreviateNum(yearStart.posts || 0, 0),
    end: abbreviateNum(yearEnd.posts, 0),
  };

  return (
    <div className="absolute inset-0 text-white font-bold text-3xl">
      {/* LIKES */}
      <span className="absolute left-[27.5%] top-[42%] -translate-x-1/2 -translate-y-1/2 animate-flyleftcentered [animation-fill-mode:both]">
        {likesFormatted.start}
      </span>
      <span className="absolute left-[73.5%] top-[42%] -translate-x-1/2 -translate-y-1/2 animate-flyrightcentered opacity-0 [animation-delay:1000ms] [animation-fill-mode:both]">
        {likesFormatted.end}
      </span>

      {/* VIEWS */}
      <span className="absolute left-[27.5%] top-[63.5%] -translate-x-1/2 -translate-y-1/2 animate-flyleftcentered [animation-delay:200ms] [animation-fill-mode:both]">
        {viewsFormatted.start}
      </span>
      <span className="absolute left-[73.5%] top-[63.5%] -translate-x-1/2 -translate-y-1/2 animate-flyrightcentered opacity-0 [animation-delay:1200ms] [animation-fill-mode:both]">
        {viewsFormatted.end}
      </span>

      {/* CREDITED POSTS */}
      <span className="absolute left-[27.5%] top-[86.7%] -translate-x-1/2 -translate-y-1/2 animate-flyleftcentered [animation-delay:400ms] [animation-fill-mode:both]">
        {postsFormatted.start}
      </span>
      <span className="absolute left-[73.5%] top-[86.7%] -translate-x-1/2 -translate-y-1/2 animate-flyrightcentered opacity-0 [animation-delay:1400ms] [animation-fill-mode:both]">
        {postsFormatted.end}
      </span>
    </div>
  );
};
